module.exports = __webpack_public_path__ + "img/sala_do_empreendedor_ouro.e83da91a.png";